export function extractExistingParams(searchParams: URLSearchParams): Record<string, string[]> {
  const entries = Array.from(searchParams.entries());

  return entries.reduce((result: Partial<Record<string, string[]>>, [key, value]) => {
    result[key] ??= [];
    result[key].push(value);
    return result;
  }, {}) as Record<string, string[]>;
}
